import { useState } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { Button } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';

import { addItemsToPortfolio, getAssignableItems } from '../../services/portfolios';

import ItemsSelectionComponent from './ItemsSelectionComponent';
import MainModal from '../modal/MainModal';
import Tooltip from '../utils/Tooltip';

import { ReactComponent as RemoveIcon } from '../../icons/remove.svg';

const AddItemsPortfolioModal = ({ onClose, source, onAddSuccess, onAddError }) => {
    const intl = useIntl();

    const [isSaving, setIsSaving] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);

    const addItems = async () => {
        try {
            setIsSaving(true);
            const items = await addItemsToPortfolio(source.properties?.id, selectedItems, {
                suppressErrorMessageHandler: true,
            });

            const updatedPortfolio = {
                ...source,
                nodes: items.concat(source.nodes.filter((node) => node.isFolder)),
            };

            setIsSaving(false);
            onAddSuccess(updatedPortfolio, selectedItems);
        } catch (error) {
            setIsSaving(false);
            onAddError(error);
        }
    };

    return (
        <MainModal
            scrollBehavior="inside"
            isOpen
            onClose={onClose}
            header={
                <FormattedMessage id="portfolios_add_items_to_portfolio" values={{ name: source.properties?.name }} />
            }
            content={
                <ItemsSelectionComponent
                    source={source}
                    getAssignableItems={getAssignableItems}
                    selectedItems={selectedItems}
                    setSelectedItems={setSelectedItems}
                    isDisplayedInModal={true}
                    isDisabled={isSaving}
                    expandAll={false}
                />
            }
            footerLeftSlot={
                <div>
                    {selectedItems.length > 0 && (
                        <Tooltip label={intl.formatMessage({ id: 'common_unselect_all' })}>
                            <StyledSelectedItemsButton
                                isDisabled={isSaving}
                                onClick={() => setSelectedItems([])}
                                ml="-14px"
                                size="sm"
                                leftIcon={<RemoveIcon />}
                                variant="ghost"
                            >
                                <FormattedMessage id="common_items_selected" values={{ n: selectedItems.length }} />
                            </StyledSelectedItemsButton>
                        </Tooltip>
                    )}
                </div>
            }
            footerRightSlot={
                <Button isLoading={isSaving} isDisabled={selectedItems.length === 0} onClick={addItems} ml={3}>
                    <FormattedMessage id="common_add_to_portfolio_btn" />
                </Button>
            }
        />
    );
};

const StyledSelectedItemsButton = styled(Button)`
    @media screen and (max-width: 375px) {
        margin-bottom: var(--chakra-space-3);
    }
`;

export default AddItemsPortfolioModal;
